import Vue from 'vue';
import Vuex from 'vuex';
import cryptocurrencies from './modules/cryptocurrencies';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    cryptocurrencies,
  },
});
